<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
    class="pulse"
  >
    <circle cx="50%" cy="50%" r="7px"></circle>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'CirclepulseSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style>
@keyframes pulse {
  from {
    opacity: 0;
  }
}

.pulse {
  fill-opacity: 1;
  transform-origin: 50% 50%;
  animation: pulse 2s infinite alternate;
}
</style>
